<template>
  <div class="layout-content-list">
    <div class="toolbar-panel-new">
      <div class="toolbar-wrap-new mt-0">
        <div class="toolbar-item-new toolbar-item-twocol" id="auto-0">
          <span class="item-label">起运日期</span>
          <el-date-picker
            v-model="tableOptions.beginTime"
            type="datetime"
            placeholder="选择开始时间"
            :clearable="false"
            value-format="timestamp"
            :picker-options="pickerTime"
          >
          </el-date-picker>
          <span>-</span>
          <el-date-picker
            v-model="tableOptions.endTime"
            type="datetime"
            placeholder="选择结束时间"
            default-time="23:59:59"
            :clearable="false"
            value-format="timestamp"
            :picker-options="pickerTime"
          >
          </el-date-picker>
        </div>
        <div class="toolbar-item-new toolbar-item-twocol" id="auto-6">
          <span class="item-label">批量搜索</span>
          <el-input
            @click.native="handleShowMore"
            :readonly="true"
            v-model.trim="batchSearch"
            :title="batchSearch"
            :maxlength="ordernumberKeywordLimit"
            placeholder="车牌、司机、手机号、运单号、客户单号"
          >
            <i slot="suffix" class="batch-search-icon"></i>
          </el-input>
        </div>
        <div class="toolbar-item-new toolbar-item-twocol" id="auto-3" v-show="!isRetracted">
          <span class="item-label">装/卸货城市</span>
          <region style="width: 100%" v-on:back-region="selectSourceCode" ref="regionFH"></region>
          <span>-</span>
          <region style="width: 100%" v-on:back-region="selectTargetCode" ref="regionXH"></region>
        </div>
        <div class="toolbar-item-new toolbar-item-onecol" id="auto-4" v-show="!isRetracted">
          <span class="item-label">装货地址</span>
          <el-input
            v-model.trim="tableOptions.sourceAddressName"
            :maxlength="addressKeywordLimit"
            placeholder="请输入装货地址"
          >
          </el-input>
        </div>
        <div class="toolbar-item-new toolbar-item-onecol" id="auto-5" v-show="!isRetracted">
          <span class="item-label">卸货地址</span>
          <el-input
            v-model.trim="tableOptions.targetAddressName"
            :maxlength="addressKeywordLimit"
            placeholder="请输入卸货地址"
          >
          </el-input>
        </div>

        <CarrierCompany
          class="toolbar-item-new toolbar-item-onecol"
          ref="CarrierCompany"
          @changeValue="changeItem('carrierCompanyCode', ...arguments)"
          v-show="!isRetracted"
        ></CarrierCompany>
        <div class="toolbar-item-new toolbar-item-onecol" id="auto-1" v-show="!isRetracted">
          <span class="item-label">运单进度</span>
          <el-select v-model="tableOptions.orderMainState" placeholder="请选择">
            <el-option v-for="item in stateArr" :label="item.label" :value="item.value" :key="item.value"> </el-option>
          </el-select>
        </div>
        <Intermediary
          class="toolbar-item-new toolbar-item-onecol"
          ref="Intermediary"
          @changeValue="changeItem('intermediary', ...arguments)"
          v-show="!isRetracted"
        ></Intermediary>
        <OrderTypeSearch
          class="toolbar-item-new toolbar-item-onecol"
          ref="orderTypeSearch"
          @changeValue="changeItem('orderType', ...arguments)"
          v-show="!isRetracted"
        ></OrderTypeSearch>
        <div class="toolbar-item-new toolbar-item-twocol" id="auto-2" v-show="!isRetracted">
          <span class="item-label">其他</span>
          <el-input
            v-model.trim="tableOptions.keyword"
            :maxlength="ordernumberKeywordLimit"
            placeholder="车牌、司机、电话、运单号、货物类型"
          ></el-input>
        </div>
      </div>
      <div class="toolbar-item-btn-new">
        <el-button type="primary" size="small" @click="screenList" id="auto-7">筛选</el-button>
        <el-button size="small" @click="resetSearch" id="auto-8">重置</el-button>
        <el-button class="ml-15 font-blue" type="text" @click="isRetracted = !isRetracted">
          {{ isRetracted ? '展开' : '收起' }} <i :class="isRetracted ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"></i
        ></el-button>
      </div>
    </div>
    <div class="btn-group-box clearfix">
      <div class="fl">
        <span class="btn-left-txt font-size16 font-bold"> 运单汇总列表 </span>
      </div>
      <div class="fr">
        <el-button size="small" type="primary" plain @click="handleCustomHeader"
          ><span class="btn-group-inner"><i class="iconfont icon_ico16px_form_zdybt"></i>自定义表头</span></el-button
        >
        <el-button
          type="primary"
          size="small"
          v-if="roleRules.indexOf('SJB_P_0016') != -1"
          @click="exportList"
          id="auto-9"
          ><span class="export-icon"></span>导出表格</el-button
        >
      </div>
    </div>
    <div class="table-custom-box" id="auto-10">
      <fe-table
        header-cell-class-name="header-cell-outer"
        :tableData="tableData"
        :columns="columns"
        border
        :show-pagination="true"
        :pagination-config="pagination"
        @pagination-current-change="handleCurrentChange"
        @pagination-size-change="handleSizeChange"
      >
        <template #orderNumber="{ scope }">
          <span>{{ scope.row.orderNumber }}</span>
          <div>
            <img
              class="guarantee-tag mr-5"
              v-if="scope.row.isCargoGuarantee === 1"
              src="../../assets/img/order/tag_list_hwbz14@2x.png"
              alt=""
            />
          </div>
        </template>
      </fe-table>
    </div>
    <batch-search
      ref="batchSearch"
      placeholder="批量输入搜索信息，信息用'、'或换行隔开；每次最多允许100条"
      :batchSearchTypeList="batchSearchTypeList"
      @bacthCallBack="bacthCallBack"
    ></batch-search>
    <el-dialog :visible.sync="dialogVisible" title="提示" :close-on-click-modal="false" custom-class="dia-tiny">
      <div class="text-c font-size16 mb-5">是否确认导出以下时段的查询结果？</div>
      <div class="text-c font-size14">
        开始时间：
        <span class="font-orange">{{ startTime }}</span>
      </div>
      <div class="text-c font-size14">
        结束时间：
        <span class="font-orange">{{ endTime }}</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="comfirm">确 定</el-button>
      </span>
    </el-dialog>
    <custom-table-header
      ref="customTableHeaderRef"
      :tableTitleType="tableTitleType"
      @backTableHead="getTableHead"
    ></custom-table-header>
  </div>
</template>
<script>
/**
 * 自动化测试id
 * 当前最大值为:10
 * @param {int} max id最大值
 * 每次变更累加 请手动更新
 * 示例：auto-0
 */
import axios from '@/api/axiosNew';
import api from '@/api/base.new.api.js';

import { setTableHeadAttribute } from '@/utils';
import { WUYI, vali } from '@/api/common';
import tableMixin from '@/utils/tableMixin';
import dateLimit from '@/api/dateLimit';
import Intermediary from '@/components/Intermediary.vue';
import CarrierCompany from '@/components/CarrierCompany.vue';
import CustomTableHeader from '@/components/CustomTableHeader.vue';
import OrderTypeSearch from '@/components/OrderTypeSearch.vue';
import BatchSearch from '@/components/BatchSearch';
export default {
  components: { Intermediary, CarrierCompany, OrderTypeSearch, CustomTableHeader, BatchSearch },
  mixins: [tableMixin],
  data() {
    return {
      pageSource: 'WaybillSum',
      isRetracted: true, //默认是隐藏
      stateArr: [],
      axiosConfig: { url: api.gatherListQuery }, // 列表接口
      columns: [],
      tableOptions: {
        keyword: '',
        beginTime: new Date(dateLimit.getThreeMonth()).getTime(),
        endTime: dateLimit.currentDayEnd.getTime(),
        sourceRegionCode: '', //省市区
        targetRegionCode: '',
        orderMainState: '1',
        sourceAddressCode: '', //装货的常用地址
        targetAddressCode: '', //卸货常用地址
        sourceAddressName: '',
        targetAddressName: '',
        listQueryType: 0,
        listQueryString: '',
        intermediary: '',
        carrierCompanyCode: '',
        orderType: null
      },
      roleRules: '',
      /* 批量搜索相关start */
      batchSearchTypeList: [
        { val: 1, name: '车牌' },
        { val: 2, name: '司机手机' },
        { val: 3, name: '司机姓名' },
        { val: 4, name: '运单号' },
        { val: 5, name: '客户单号' }
      ],
      tableTitleType: 13,
      batchSearch: '',
      /* 批量搜索相关end */
      dialogVisible: false,
      pickerTime: {
        disabledDate: time => {
          if (time > dateLimit.currentDayEnd.getTime()) {
            return true;
          }
          return false;
        }
      }
    };
  },
  computed: {
    startTime() {
      const startTime = this.tableOptions.beginTime;
      if (startTime) {
        if (typeof startTime == 'number') {
          return WUYI.timeFormat(startTime) + ' ' + WUYI.formatDate(startTime);
        } else {
          return startTime;
        }
      } else {
        return '';
      }
    },
    endTime() {
      const endTime = this.tableOptions.endTime;
      if (endTime) {
        if (typeof endTime == 'number') {
          return WUYI.timeFormat(endTime) + ' ' + WUYI.formatDate(endTime);
        } else {
          return endTime;
        }
      } else {
        return '';
      }
    }
  },

  created() {
    this.stateArr = [
      { label: '全部', value: '1' },
      { label: '待装货', value: '2' },
      { label: '配送中', value: '3' },
      { label: '协商中', value: '4' },
      { label: '历史运单', value: '5' },
      { label: '取消运单', value: '6' }
    ];
    this.roleRules = WUYI.currentData.userrole;
    this.getTableHead();
  },
  methods: {
    async getTableHead() {
      let res = await axios.post(api.tableTitleQuery, { tableTitleType: this.tableTitleType });
      let customArr = [
        {
          prop: 'operation',
          customAtt: {
            'min-width': 210,
            fixed: 'right',
            'header-align': 'right',
            align: 'right'
          }
        }
      ];
      this.columns = setTableHeadAttribute(res.data, customArr);
    },
    handleCustomHeader() {
      this.$refs.customTableHeaderRef.openDia();
    },
    selectSourceCode(data) {
      this.tableOptions.sourceRegionCode = data != null && data.regionCode ? data.regionCode : '';
    },
    selectTargetCode(data) {
      this.tableOptions.targetRegionCode = data != null && data.regionCode ? data.regionCode : '';
    },
    //筛选查询
    async screenList() {
      if (!WUYI.checkDate(this.tableOptions.beginTime, this.tableOptions.endTime)) return;
      WUYI.trackEventSearch(this.sendOptions, this.pageSource, 'searchText');
      await this.handleSearch();
    },
    beforeResolve(result) {
      if (!result.data || result.data.length == 0) {
        this.tableData = [];
        this.$message.warning('未查询到数据，请重新筛选');
        return false;
      }
      return true;
    },

    //导出
    exportList() {
      if (this.tableData.length == 0) {
        this.$message.warning('未查询到数据，请重新筛选');
        return;
      }
      this.dialogVisible = true;
    },
    comfirm() {
      const exportData = { ...this.sendOptions };
      WUYI.trackEventSearch(this.sendOptions, this.pageSource, 'exportText');
      axios.post(api.gatherListExport, exportData).then(res => {
        this.dialogVisible = false;
        this.$message.success('提交成功，请稍后在“下载管理”中查看');
      });
    },
    // 批量搜索
    bacthCallBack(data) {
      const { batchType, batchValues, batchSearchValShow } = data;
      this.batchSearch = batchSearchValShow;
      this.tableOptions.listQueryType = batchType;
      this.tableOptions.listQueryString = batchValues;
      this.screenList();
    },
    handleShowMore() {
      this.$refs.batchSearch.openDia();
    },
    resetSearch() {
      // 清除条件
      this.$refs.regionFH.resetData();
      this.$refs.regionXH.resetData();
      this.batchSearch = '';
      this.$refs.Intermediary.intermediary = '';
      this.$refs.CarrierCompany.carrierCompanyCode = '';
      this.$refs.orderTypeSearch.orderType = null;
      this.resetOption(false);
    },
    changeItem(key, val) {
      this.tableOptions[key] = val;
    }
  }
};
</script>
<style>
.batchSearch-custom-dialog {
  width: 536px;
}
.ml-15 {
  margin-left: 15px !important;
}
.batch-search-icon {
  display: block;
  background: url('../../assets/img/wallet/ico_sdfh_gd@2x.png') no-repeat;
  width: 17px !important;
  height: 15px !important;
  background-size: 17px 15px !important;
  margin-top: 10px;
  cursor: pointer;
}
</style>
